@if (settings?.featuresVisible !== false) {
<section class="operation-settings" [class.preview]="presentation === 'preview'" aria-label="NEST利用機能とイベント担当者">
  @if (loading) {
    <div class="loading"><mat-spinner diameter="32"></mat-spinner></div>
  } @else if (loadError) {
    <p class="error" role="alert">{{ loadError }}</p>
  } @else if (settings) {
    <div class="operation-row">
      <div class="operation-label">NEST利用機能</div>
      <div class="operation-content feature-options">
        @if (canEdit) {
          <label class="feature-option" [class.disabled]="attendanceDisabled">
            <mat-checkbox [(ngModel)]="settings.attendanceSelected" [disabled]="attendanceDisabled"></mat-checkbox>
            <span><strong>出欠・参加管理を利用する</strong><small>対象者への出欠依頼、当日受付、実出席の確定を行います。</small></span>
          </label>
          <label class="feature-option" [class.disabled]="surveyDisabled">
            <mat-checkbox [(ngModel)]="settings.surveySelected" [disabled]="surveyDisabled"></mat-checkbox>
            <span><strong>イベントアンケートを利用する</strong><small>参加後の評価・改善点を集計し、結果Excelを報告書へ添付します。</small></span>
          </label>
          <p class="hint">企画書の承認完了後は、選択した機能だけを左メニューに表示します。</p>
          @if (!settings.releaseControls.attendance.canWrite) {
            <p class="release-note">出欠・参加管理は組織設定により新しく利用開始できません。</p>
          }
          @if (!settings.releaseControls.survey.canWrite) {
            <p class="release-note">イベントアンケートは組織設定により新しく利用開始できません。</p>
          }
        } @else {
          <div class="feature-summary">
            @if (settings.attendanceSelected) { <span>出欠・参加管理</span> }
            @if (settings.surveySelected) { <span>イベントアンケート</span> }
            @if (!settings.attendanceSelected && !settings.surveySelected) { <span class="not-selected">利用しない</span> }
          </div>
        }
      </div>
    </div>

    @if (managerRowVisible) {
    <div class="operation-row">
      <div class="operation-label">イベント担当者</div>
      <div class="operation-content">
        <div class="manager-line">
          @if (!settings.managers.length) { <span>{{ managerSummary }}</span> }
          @if (canEdit) {
            <button mat-stroked-button type="button" (click)="openManagerDialog()">担当者を追加</button>
          }
        </div>
        @if (settings.managers.length) {
          <div class="manager-list">
            @for (manager of settings.managers; track manager.id) {
              <span class="manager-chip">
                <span>
                  {{ manager.position }} {{ manager.name }}
                  @if (manager.affiliations?.length) {
                    <small>{{ manager.affiliations?.join('／') }}</small>
                  }
                </span>
                @if (canEdit) {
                  <button type="button" [attr.aria-label]="manager.name + 'を解除'" (click)="removeManager(manager.id)">×</button>
                }
              </span>
            }
          </div>
        }
        <p class="hint">追加した担当者は、選択した機能の設定・編集・受付・集計確定をすべて行えます。<br>なお、企画書の起票者と承認ルートの人も操作できます。管理権限だけでは操作できません。</p>
      </div>
    </div>
    }
    @if (canEdit && presentation === 'preview') {
      <div class="preview-edit-controls">
        @if (reasonRequired) {
          <label class="reason-field" for="operation-change-reason">変更理由</label>
          <textarea id="operation-change-reason" [(ngModel)]="reason" maxlength="500" rows="2" placeholder="承認完了後に変更する理由を入力"></textarea>
        }
        <div class="actions">
          <button mat-stroked-button type="button" [disabled]="saving" (click)="cancelEditing()">キャンセル</button>
          <button mat-raised-button class="save-button" type="button" [disabled]="saving || !hasPendingChanges" (click)="save()">
            {{ saving ? '保存中' : '変更を保存' }}
          </button>
        </div>
      </div>
    }
    @if (presentation === 'edit') {
      <p class="save-with-plan">利用機能とイベント担当者は、企画書の「保存」で一緒に保存されます。</p>
    } @else if (canConfigure && !editing) {
      <div class="preview-actions">
        <button mat-stroked-button type="button" (click)="startEditing()">運営設定を変更</button>
      </div>
    }
    @if (!canConfigure && settings.capabilities.isAssignedManager) {
      <p class="read-only-note">運営担当者として、選択済み機能の操作ができます。機能と担当者の変更は企画書の起票者・承認ルートの人が行います。</p>
    }
  }
</section>

}
